import React from "react";
import { toast } from "react-toastify";

const OrderInvoiceShareModal = ({ platforms = [], pdfUrl, onClose }) => {
  const handleNativeShare = async () => {
    if (!pdfUrl || !navigator.share) {
      return;
    }

    try {
      await navigator.share({
        title: "فاکتور سفارش",
        text: "فاکتور سفارش",
        url: pdfUrl,
      });
    } catch (error) {
      if (error?.name !== "AbortError") {
        window.open(pdfUrl, "_blank", "noopener,noreferrer");
      }
    }
  };

  const handlePlatformClick = (event, platform) => {
    if (!platform?.share_url) {
      event.preventDefault();
      toast.error("لینک ارسال برای این پیام‌رسان در دسترس نیست.", {
        position: "top-center",
        autoClose: 4000,
      });
      return;
    }

    if (!pdfUrl) {
      event.preventDefault();
      toast.error("فایل فاکتور هنوز آماده نشده است.", {
        position: "top-center",
        autoClose: 4000,
      });
    }
  };

  return (
    <div className="sort-modal order-invoice-share-modal">
        <div className="sort-modal-head">
          <h2>ارسال فاکتور برای مشتری</h2>
          <button type="button" className="sort-modal-close" onClick={onClose} aria-label="بستن">
            ×
          </button>
        </div>

        {platforms.length === 0 ? (
          <p className="order-invoice-share-empty">
            دسترسی ارسال فاکتور از پیام‌رسان‌ها برای حساب شما فعال نیست.
          </p>
        ) : (
          <div className="order-invoice-share-list">
            {platforms.map((platform) => (
              <a
                key={platform.key}
                href={platform.share_url}
                target="_blank"
                rel="noopener noreferrer"
                className="order-invoice-share-item"
                onClick={(event) => handlePlatformClick(event, platform)}
              >
                {platform.icon ? (
                  <img src={platform.icon} alt={platform.label} width={28} height={28} />
                ) : null}
                <span>{platform.label}</span>
              </a>
            ))}
          </div>
        )}

        {pdfUrl ? (
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="order-invoice-share-native"
          >
            مشاهده / دانلود فایل PDF
          </a>
        ) : null}

        {pdfUrl && typeof navigator !== "undefined" && navigator.share ? (
          <button type="button" className="order-invoice-share-native" onClick={handleNativeShare}>
            اشتراک‌گذاری با برنامه‌های گوشی
          </button>
        ) : null}
    </div>
  );
};

export default OrderInvoiceShareModal;
